<template>
  <div>
    <div class="common-form">添加运营城市</div>
    <!-- 请输入内容 -->
    <el-form size="small" ref="form" :model="form" label-width="100px">
      <el-form-item label="请选择城市">
        <!-- <el-cascader :options="areaList" :props="{ value: 'id', label: 'name', children:'children', multiple: true}" clearable></el-cascader> -->
        <el-cascader :options="areaList" :props="{ value: 'id', label: 'name' }" clearable v-model="myvalue"></el-cascader>
        <el-button size="small" type="primary" icon="el-icon-plus" @click="add_city">添加运营城市</el-button>
      </el-form-item>
    </el-form>
    <!-- 城市列表 -->
    <div class="product-content">
      <div class="table-wrap">
        <el-table size="small" :data="getData" border style="width: 100%" v-loading="loading">
          <el-table-column prop="" align="center" label="已添加的城市">
            <template slot-scope="scope">
              <span>{{ scope.row.province }}{{ scope.row.city ? scope.row.city : "" }}{{ scope.row.region ?
                scope.row.region : "" }}</span>
            </template>
          </el-table-column>
          <el-table-column fixed="right" align="center" label="操作" width="220">
            <template slot-scope="scope">
              <el-button @click="deleteClick(scope.row.serviceCityId)" type="danger" size="small">删除
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <!--分页-->
    <div class="pagination">
      <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" background
        :current-page="curPage" :page-size="pageSize" layout="total, prev, pager, next, jumper" :total="totalDataNumber">
      </el-pagination>
    </div>
  </div>
</template>

<script>
import DataApi from "@/api/data.js";
import Technician from "@/api/technician.js";
export default {
  data() {
    return {
      city: "",
      /*是否加载完成*/
      loading: true,
      /*列表数据*/
      getData: [],
      /*门店列表数据*/
      storeList: [],
      /*一页多少条*/
      pageSize: 15,
      /*一共多少条数据*/
      totalDataNumber: 0,
      /*当前是第几页*/
      curPage: 1,
      myvalue: [],
      props: {
        value: "id",
        label: "name",
        multiple: true
        
      },
      areaList: [],

      form: {
        province_id: "",
        city_id: "",
        region_id: ""
      }
    };
  },
  created() {
    this.get_city();
    this.getchinaData();
  },

  methods: {
    /*初始化城市id*/
    initCity() {
      this.form.city_id = "";
    },

    /*初始化区id*/
    initRegion() {
      this.form.region_id = "";
    },

    getchinaData() {
      let self = this;
      DataApi.getnewCity({
      }, true)
        .then(res => {
          console.log("========areaList", res.data);
          self.areaList = res.data;
        })
        .catch(error => { });
    },
    /*选择第几页*/
    handleCurrentChange(val) {
      this.curPage = val;
      this.loading = true;
      this.get_city();
    },

    /*每页多少条*/
    handleSizeChange(val) {
      this.curPage = 1;
      this.pageSize = val;
      this.get_city();
    },

    // 添加城市
    add_city() {
      console.log(this.myvalue);
      var timestamp = Date.now();
      console.log(timestamp);
      if (this.myvalue.length == 0) {
        this.$message({
          message: "请选择城市",
          type: "error"
        });
        return;
      }
      let a = {
        city_data: []
      };
      // this.myvalue.forEach((item) => {
      //   let a1 = item.join(",");
      //   a.city_data.push(a1);
      // });
      let a1 = this.myvalue.join(",");
      a.city_data = a1;
      Technician.addCity(a, true)
        .then(data => {
          if (data.code == 1) {
            this.get_city();
            this.$message({
              message: data.msg,
              type: "success"
            });
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    // 获取城市列表
    get_city() {
      let page = this.curPage;
      let list_rows = this.pageSize;
      Technician.getCity(
        {
          page,
          list_rows
        },
        true
      )
        .then(data => {
          this.loading = false;
          if (data.code == 1) {
            this.getData = data.data.data;
            this.totalDataNumber = data.data.total;
          }
        })
        .catch(err => {
          this.loading = false;
          console.log(err);
        });
    },
    // 删除城市
    deleteClick(e) {
      let serviceCityId = e;
      this.$confirm("此操作将永久删除该记录, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          self.loading = true;
          Technician.deleteCity(
            {
              serviceCityId
            },
            true
          )
            .then(data => {
              this.get_city();
              console.log(data);
            })
            .catch(err => {
              console.log(err);
            });
        })
        .catch(() => {
          self.loading = false;
        });
    }
  }
};
</script>

<style scoped>
.product-content {
  margin-top: 20px;
}
</style>



// WEBPACK FOOTER //
// src/views/citymanager/citymanager/index.vue